import { SummaryPaymentDetailModel } from "src/app/core/view-models/about-court-fees";

export const userDataSummayPayment:SummaryPaymentDetailModel = {
    checkBill: 2!,
    choosePayment: 1!,
    paymentOption: 5!,
    statusCourtFees: 2!,
    refCode: '220208-WPDE',
    filingDate: new Date("February 1, 2022 19:05:00"),
    prefixName: 'นาง',
    firstName: 'ศศิธร',
    lastName: 'วรสิงห์',
    sumCapital: 20000,
    sumFee: 400,
    combinePayDate: null!,
    combinePayCompleteDate:null!,
    combinePayStatus : null!,
    userAccuser: {
        suiT_ACC_DATE: null!,
        suiT_BLACK_NO: 1,
        suiT_RED_NO: 1,
        suiT_BLACK_YEAR: '2564',
        suiT_RED_YEAR: '2565',
        courtName: 'ศาลปกครองกลาง',
        secCode: 'คดีหมายเลขดำที่',
        items: [
            {
                groupId: 0,
                groupName:'ผู้ฟ้องคดี',
                accName: 'นางศศิธร วรสิงห์',
                accId: 101,
                capital: 10000,
                fee: 200,
                preCapital: 100,
                preFees: 2,
                payDate:null!,
                payCompleteDate:new Date("February 15, 2022 12:05:00"),
                payStatus:null!,
                seq:  1
            },
            {
                groupId: 0,
                groupName:'ผู้ฟ้องคดี',
                accName: 'นางสาววรรษมน หงษ์ประชา',
                accId: 102,
                capital: 10000,
                fee: 200,
                preCapital: 10000,
                preFees: 200,
                payDate:null!,
                payCompleteDate:null!,
                payStatus:null!,
                seq:  2
            },
            {
                groupId: 0,
                groupName:'ผู้ฟ้องคดี',
                accName: 'นายสมจิตร หงษ์ประชา',
                accId: 103,
                capital: 10000,
                fee: 200,
                preCapital: 10000,
                preFees: 200,
                payDate:null!,
                payCompleteDate:null!,
                payStatus:null!,
                seq:  3
            },
            {
                groupId: 0,
                groupName:'ผู้ฟ้องคดี',
                accName: 'นายสมใจ หงษ์ประชา',
                accId: 103,
                capital: 10000,
                fee: 200,
                preCapital: 10000,
                preFees: 200,
                payDate:null!,
                payCompleteDate:null!,
                payStatus:null!,
                seq:  4
            }
        ]
        ,
    },
    plaintiffs: [
        {
            groupId: 0,
            groupName:'ผู้ฟ้องคดี',
            accName: 'นางศศิธร วรสิงห์',
            accId: 101,
            capital: 10000,
            fee: 200,
            preCapital: 10000,
            preFees: 200,
            payDate:null!,
            payCompleteDate:null!,
            payStatus:null!,
            seq:  1
        },
        {
            groupId: 0,
            groupName:'ผู้ฟ้องคดี',
            accName: 'นางสาววรรษมน หงษ์ประชา',
            accId: 102,
            capital: 10000,
            fee: 200,
            preCapital: 10000,
            preFees: 200,
            payDate:null!,
            payCompleteDate:null!,
            payStatus:null!,
            seq:  2
        },

    ],
    prosecutors: [
        {
            groupId: 0,
            groupName:'ผู้ถูกฟ้องคดี',
            accName: 'ผู้อำนวยการสำนักวิทยาการสารสนเทศ',
            accId: 0,
            capital: null!,
            fee: null!,
            preCapital: 0,
            preFees: 0,
            payDate:null!,
            payCompleteDate:null!,
            payStatus:null!,
            seq:  1
        },
        {
            groupId: 0,
            groupName:'ผู้ถูกฟ้องคดี',
            accName: 'นาย สมชาย ยอดคน',
            accId: 0,
            capital: null!,
            fee: null!,
            preCapital: 0,
            preFees: 0,
            payDate:null!,
            payCompleteDate:null!,
            payStatus:null!,
            seq:  2
        },
        {
            groupId: 0,
            groupName:'ผู้ถูกฟ้องคดี',
            accName: 'นาง สมหญิง ยอดคน',
            accId: 0,
            capital: null!,
            fee: null!,
            preCapital: 0,
            preFees: 0,
            payDate:null!,
            payCompleteDate:null!,
            payStatus:null!,
            seq:  3
        },
    ],
    additionalPay:[
        {
            checkBill: 2!,
            choosePayment: 1!,
            paymentOption: 5!,
            payDate:new Date("February 15, 2022 12:05:00"),
            sumCapital: 20000,
            sumFee: 400,
            plaintiffs: [
                {
                    groupId: 0,
                    groupName:'ผู้ฟ้องคดี',
                    accName: 'นางศศิธร วรสิงห์',
                    accId: 101,
                    capital: 2000,
                    fee: 40,
                    preCapital: 10000,
                    preFees: 200,
                    payDate:null!,
                    payCompleteDate:null!,
                    payStatus:null!,
                    seq:  1
                },
        
            ]
        },
        {
            checkBill: 2!,
            choosePayment: 1!,
            paymentOption: 6!,
            payDate:new Date("February 20, 2022 10:05:00")!,
            sumCapital: 10000,
            sumFee: 200,
            plaintiffs: [
                {
                    groupId: 0,
                    groupName:'ผู้ฟ้องคดี',
                    accName: 'นางสาววรรษมน หงษ์ประชา',
                    accId: 102,
                    capital: 100,
                    fee: 2,
                    preCapital: 10000,
                    preFees: 200,
                    payDate:null!,
                    payCompleteDate:null!,
                    payStatus:null!,
                    seq:  2
                },
                {
                    groupId: 0,
                    groupName:'ผู้ฟ้องคดี',
                    accName: 'นายสมชาย หงษ์ประชา',
                    accId: 102,
                    capital: 5000,
                    fee: 100,
                    preCapital: 10000,
                    preFees: 200,
                    payDate:null!,
                    payCompleteDate:null!,
                    payStatus:null!,
                    seq:  2
                },
            ]
        },
    ]
}